import clsx from 'clsx'

import { styles } from './styles'

import ButtonLink from '@lno/core/components/ButtonLink'
import { GASelectContentEvent } from '@lno/core/modules/analytics/events'
import { DesenrolaBrasil } from './DesenrolaBrasil'
import { URLS } from './constants'
const jsxScope = `jsx-${styles.__hash}`

interface Props {
  className?: string
}

export function GovernmentDebtNegotiationProgramSection({ className }: Props) {
  const handleEvent = () => {
    return GASelectContentEvent.checkAvailableDiscounts()
  }

  return (
    <section className={clsx('debt-negotiation-program-section', className)}>
      <div
        className={clsx(
          'debt-negotiation-program-section__content-wrapper',
          className
        )}
      >
        <DesenrolaBrasil.Title />
        <DesenrolaBrasil.Image />
        <DesenrolaBrasil.Description />
        <ButtonLink
          href={URLS.desenrolaOffersWeb}
          color="primary"
          onClick={handleEvent}
          className={clsx(jsxScope, 'debt-negotiation-program-section__button')}
        >
          Ver ofertas disponíveis
        </ButtonLink>
      </div>
      <style jsx>{styles}</style>
    </section>
  )
}

GovernmentDebtNegotiationProgramSection.defaultProps = {}

export default GovernmentDebtNegotiationProgramSection
